import type { PriceLine } from './price-line'

export const PAYMENT_LINE_TYPE_IMMEDIATE = 'IMMEDIATE'
export const PAYMENT_LINE_TYPE_TERM = 'TERM'
export const PAYMENT_LINE_STATUS_PENDING = 'PENDING'

export type PaymentLineType = PAYMENT_LINE_TYPE_IMMEDIATE | PAYMENT_LINE_TYPE_TERM
export type PaymentLineStatus = PAYMENT_LINE_STATUS_PENDING

class PaymentLine {
  type: string
  status: string
  dueDate: string
  priceLines: PriceLine[]
  totalPriceLine: PriceLine
}

const buildPaymentLine = function (type: string, status: string, dueDate: string, priceLines: PriceLine[], totalPriceLine: PriceLine): PaymentLine {
  const paymentItemSpecification = new PaymentLine()
  paymentItemSpecification.type = type
  paymentItemSpecification.status = status
  paymentItemSpecification.dueDate = dueDate
  paymentItemSpecification.priceLines = priceLines
  paymentItemSpecification.totalPriceLine = totalPriceLine
  return paymentItemSpecification
}

export {
  PaymentLine,
  buildPaymentLine
}



// WEBPACK FOOTER //
// ./src/types/payment-line.js